<div class="loading-spinner-wrapper">
    <div class="loading-spinner"></div>
</div>
